import {RefCallback, useState} from 'react';
import {useOnResize} from './useOnResize';

interface OffsetHeight<T extends HTMLElement> {
  offsetHeight?: number;
  ref: RefCallback<T>;
}

export function useOffsetHeight<T extends HTMLElement = HTMLElement>(): OffsetHeight<T> {
  const [offsetHeight, setOffsetHeight] = useState<number>();
  const {ref} = useOnResize((resized) => setOffsetHeight(resized.offsetHeight));
  return {offsetHeight, ref};
}
